import { render, staticRenderFns } from "./SelectionButton.vue?vue&type=template&id=e8c6e166&scoped=true"
import script from "./SelectionButton.vue?vue&type=script&lang=js"
export * from "./SelectionButton.vue?vue&type=script&lang=js"
import style0 from "./SelectionButton.vue?vue&type=style&index=0&id=e8c6e166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c6e166",
  null
  
)

export default component.exports